module.exports = __webpack_public_path__ + "media/legacy/components/MainSection/bottom-right-decorator-afc17dc6a1564e316c5867f0304df84a.png";